export const PRODUCT_CONSTANTS = {
  subscription: "Subscription",
  noSubscription: "No subscription",
};

export const DELIVERY_LABELS_BY_TYPE = {
  PREMIUM: "Next day delivery",
  FREE: "Standard delivery",
};
